import styled from "styled-components";

export const DownlinesContainer = styled.div`
  padding-inline: 15px;
`;

export const DownlinesTopCard = styled.div`
  /* height: 100px; */
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  /* width: calc(100% - 40px); */
  margin-block: 5px;
`;

export const DownlinesTopCardButton = styled.button`
  display: flex;
  justify-content: space-evenly;
  border-radius: 15px;
  width: calc(100% - 10px);
  height: 35px;
  font-weight: bold;
  margin-inline: 5px;

  & > svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

export const DownlinesCard = styled.div`
  border: 1px solid rgba(223, 232, 115, 0.2);
  padding: 20px;
  margin-block: 40px 30px;
  display: flex;
  flex-direction: column;
`;
